import IntroComp from './introComp';
import ProjComp from './projComp';
import "./index.css";


function App() {
  return (
    <div className="App">

        <IntroComp/>
        
        <ProjComp/>
     
    </div>
  );
}

export default App;
